<main class="w-full bg-white shadow-sm">
  <app-dynamic-grid
    [gridConfig]="gridConfig"
    [getDataUrl]="getDataUrl"
    [toggleUrl]="toggleUrl"
    [sortBy]="'modifiedAt'"
    [sortOrder]="'desc'"
    (addClicked)="onAddHandler()"
    (editClicked)="onEditHandler($event)"
    (onToggleShowToastEmitter)="showToast($event)"
  ></app-dynamic-grid>

  <app-drawer
    [drawerModel]="drawerModel"
    [drawerConfig]="drawerInputConfig"
    [AddDataURL]="addDataUrl"
    [editDataURL]="editDataUrl"
    [removeLevel]="false"
    [maxDrawerHeight]="'max-h-[450px]'"
    (refresh)="refreshHandler()"
    [createDrawerTitle]="'Create New Dentrix Adjustment Type'"
    [updateDrawerTitle]="'Update Dentrix Adjustment Type'"
    [hasTwoColumns]="false"
    (resetData)="resetEntry()"
  ></app-drawer>

  <app-toast></app-toast>
</main>
